module.exports = __webpack_public_path__ + "static/savings-card-print-6e656fdd0337decec2a550cbae721cd3.png";